import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  loaderSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loaderMap: Map<string, boolean> = new Map<string, boolean>();

  constructor() { }

  setLoading(loading: boolean, url: string, error: boolean): void {
    if (!url) {
      throw new Error('The request URL must be provided to the LoadingService.setLoading function');
    }
    if (error) {
      this.loaderMap.clear();
    }
    else if (loading === true) {
      this.loaderMap.set(url, loading);
      this.loaderSubject.next(true);
    } else if (loading === false && this.loaderMap.has(url)) {
      this.loaderMap.delete(url);
    }

    if (this.loaderMap.size === 0) {
      this.loaderSubject.next(false);
    }
  }

  setLoaderStateActive(active: boolean, url: string) {
    if(active) {
      this.setLoading(true, url, false);
    } else {
      this.setLoading(false, url, false);
    }
  }
}
